import React from "react";
import settings from "../../settings";

const getSsn = (ssn, props) => {
  if (!ssn || ssn.length === 0) {
    return "N/A";
  }
  if (ssn.length !== 11) {
    return "";
  }
  if (props.userAccount.btType !== "4") {
    if (ssn.length === 0) {
      return "N/A";
    } else if (
      props.userAccount.btType === "3" ||
      props.userAccount.mastSSNMask === settings.ssnMask.HideAll
    ) {
      return "XXX-XX-XXXX";
    }
    if (props.userAccount.mastSSNMask === settings.ssnMask.ShowLastFour) {
      return `XXX-XX-${ssn.substring(7, 11)}`;
    }
    if (
      props.userAccount.mastSSNMask === settings.ssnMask.HideLastFour ||
      (localStorage.userGlb && localStorage.userGlb.glb === "9")
    ) {
      return `${ssn.substring(0, 6)}-XXXX`;
    }
    if (
      ssn.toLowerCase().indexOf("x") !== -1 ||
      !props ||
      !props.handleNewSearchClick
    )
      return ssn;
    return (
      <span
        role="button"
        tabIndex={0}
        onClick={() => props.handleNewSearchClick(this, "SSN", ssn, ssn)}
        className={"url-link"}
      >
        {ssn}
      </span>
    );
  }
  return "";
};

export default getSsn;



// WEBPACK FOOTER //
// ./src/components/common/Ssn.js